<template>
  <v-card
    cols='12' sm='8'
    elevation='1'
    class='mb-5'
  >
    <v-card-title v-html="i18nReservationCode"/>

    <v-card-text>
      <v-row>
        <v-icon large class='ml-2'>mdi-book-outline</v-icon>
        <v-col>
          {{ $t('order.attributes.ota') }}<br>
          <strong>{{ order.ota || 'nd' }}</strong>
        </v-col>

        <v-icon large>mdi-home-city-outline</v-icon>
        <v-col>
          {{ $t('reservation.attributes.apartment') }}<br>
          <strong v-html="apartment_link"></strong>
        </v-col>
      </v-row>

      <v-row>
        <v-icon large class='ml-2'>mdi-home-import-outline</v-icon>
        <v-col>
          {{ $t('reservation.attributes.checkin_date') }}<br>
          <strong>{{ formattedDate(reservation.checkin_date) }}</strong>
        </v-col>

        <v-icon large>mdi-home-export-outline</v-icon>
        <v-col>
          {{ $t('reservation.attributes.checkout_date') }}<br>
          <strong>{{ formattedDate(reservation.checkout_date) }}</strong>
        </v-col>
      </v-row>

      <v-row>
        <v-icon large class='ml-2'>mdi-weather-night</v-icon>
        <v-col>
          {{ $t('reservation.attributes.nights') }}<br>
          <strong>{{ bookedNights }}</strong>
        </v-col>

        <v-icon large>mdi-account-multiple</v-icon>
        <v-col v-bind:class="{ 'incomplete': reservation.guests.length != reservation.booked_guests}">
          {{ $t('reservation.attributes.guests') }}<br>
          <strong>{{ reservation.guests.length }} / {{ reservation.booked_guests }}</strong>
        </v-col>
      </v-row>

      <v-row v-if="redirected != 'otp'">
        <v-icon large class='ml-2'>mdi-sign-real-estate</v-icon>
        <v-col>
          {{ $t('reservation.attributes.guest_checkin_state') }} <v-icon v-if="checkinCompleted" color="success">mdi-check-bold</v-icon><br>
          <strong>{{ i18nCheckinState }}</strong>
        </v-col>

        <v-icon large>mdi-account-search-outline</v-icon>
        <v-col>
          {{ $t('reservation.attributes.guests_recognition') }}<br>
          <v-chip
            v-if="reservation.guests_recognition"
            small
            color="success"
          >
            {{ $t('commons.remotely') }}
          </v-chip>
          <v-chip
            v-else
            small
          >
            {{ $t('commons.in_person') }}
          </v-chip>
        </v-col>
      </v-row>

      <v-row
        v-for="guest in reservation.guests"
        :key="guest.id"
      >
        <v-col>
          <GuestCard :guest="guest"/>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <v-btn
        v-if="checkinCompleted && apartment_promo_document"
        large
        block
        color='success'
        :href="apartment_promo_document"
      >
        {{ $t('order.show.download_voucher') }}
        <v-icon class='ml-3'>mdi-download-outline</v-icon>
      </v-btn>

      <v-btn
        v-else-if="!checkinCompleted && customer && redirected != 'otp'"
        large
        block
        color='primary'
        :disabled="!assigned"
        :to='{
          name: "checkinGuests",
          params: {
            uuid: order.uuid,
            reservation_id: reservation.id,
          }
        }'
      >
        {{ $t('order.checkin.show') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { utilityMixin } from '../../mixins/utility_mixin'
  import { reservationMixin } from '../../mixins/reservation_mixin'
  import { apartmentMixin } from '../../mixins/apartment_mixin'
  import { guestMixin } from '../../mixins/guest_mixin'
  import { orderCustomerMixin } from '../../mixins/order_customer_mixin'
  import GuestCard from '../guests/guest_card'

  export default {
    components: {
      GuestCard
    },
    mixins: [
      utilityMixin,
      reservationMixin,
      apartmentMixin,
      guestMixin,
      orderCustomerMixin,
    ],
    props: {
      order: {
        type: Object,
        required: true
      },
      reservation: {
        type: Object,
        required: true
      },
      assigned: {
        type: Boolean,
        default: false,
        required: false
      },
      redirected: {
        type: String,
        default: null,
        required: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .incomplete {
    color: red;
  }
</style>
